import BaseContact from "./base-contact.js";

("use strict");

export class Application extends BaseContact {
    constructor(args = []) {
        super(args);

        this.contact = {
            id: "contact-shakyou-no-tsudoi",
            route: "/api/chisan/v1/mail/",
        };

        this.setLog("[Extension] ", "Contact Shakyou no Tsudoi");
        this.setForms();
    }
}

window.Application = new Application();
